import React, { Suspense } from 'react';

import { closeNotPremiumModal } from '@redux/layout';
import { isNotPremiumModalOpenSelector } from '@redux/layout/selectors';
import { useDispatch, useSelector } from 'react-redux';

import Loader from 'components/shared/Loader';
import { isAndroidBefore10, isBrowserCompatible } from 'services/helpers/browser';
import { lazyWithRetry } from 'services/helpers/lazyWithRetry';
import { Modal } from 'shared-types/user';

import { NotPremiumMessage } from '../CannotPlaySongModal/CannotPlaySongModal';

const AndroidNotCompatibleModal = lazyWithRetry(() => import('../AndroidNotCompatibleModal'));
const BrowserNotCompatibleModal = lazyWithRetry(() => import('../BrowserNotCompatibleModal'));
const CannotPlaySongModal = lazyWithRetry(() => import('../CannotPlaySongModal'));
const OngoingOfferDesktopModal = lazyWithRetry(() => import('../OngoingOfferDesktopModal'));

interface Props {
  offersModalConfig: Modal | undefined;
  isTrialOngoingDisplayed: boolean;
  hideTrialOngoing: () => void;
}

const DesktopModal: React.FC<Props> = ({
  offersModalConfig,
  isTrialOngoingDisplayed,
  hideTrialOngoing,
}) => {
  const dispatch = useDispatch();
  const isNotPremiumModalOpen = useSelector(isNotPremiumModalOpenSelector);

  return (
    <Suspense fallback={<Loader />}>
      {isAndroidBefore10() ? (
        <AndroidNotCompatibleModal />
      ) : !isBrowserCompatible() ? (
        <BrowserNotCompatibleModal />
      ) : (
        <>
          <CannotPlaySongModal
            isOpen={isNotPremiumModalOpen}
            onClose={() => dispatch(closeNotPremiumModal())}
            Message={NotPremiumMessage}
          />
          <OngoingOfferDesktopModal
            offersModalConfig={offersModalConfig}
            isTrialOngoingDisplayed={isTrialOngoingDisplayed}
            hideTrialOngoing={hideTrialOngoing}
          />
        </>
      )}
    </Suspense>
  );
};

export default DesktopModal;
